<template>
  <div id="app">
    <h1>Model Coordinator</h1>
    <!-- Dropdown Menu -->
    <label for="dropdown">Please choose a model for execution:</label>
    <select id="dropdown" v-model="selectedOption">
      <option v-for="option in options" :key="option.id" :value="option.id">
        {{ option.title }}
      </option>
    </select>
    <br>
    <br>
    <div v-if="selectedOption === 'modelserver-roadtwin:tm_aarhus_m24_v240911'">
      <label for="scenarios">Please choose a scenario for the traffic model:</label>
      <select id="scenarios" v-model="selectedScenario">
        <option v-for="scenario in scenarios" :key="scenario.key" :value="scenario.parameters">
          {{ scenario.title }}
        </option>
      </select>
    </div>
    <br>
    <br>
    <!-- Button -->
    <button @click="executeAction">Execute</button>

    <!-- Display Result -->
    <p v-if="resultMessage">{{ resultMessage }}</p>
    <br>
    <br>
    <!-- Table -->
    <table id="job-table" class="display" style="width:100%">
      <thead>
        <tr>
          <th>Server</th>
          <th>Job started at</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="job in previousJobs" :key="job.started" :value="job.job_id">
          <td>{{ job.server_url }}</td>
          <td>{{ job.started }}</td>
          <td :class="{'green-text': job.status == 'successful'}">{{ job.status }}</td>
          <td><button @click="dataPreview(job.job_id)">Preview</button></td>
        </tr>
      </tbody>
    </table>
    <p v-if="resultData">{{ resultData }}</p>
  </div>
</template>

<script>
//import $ from 'jquery';
import trafficScenarios from '../assets/trafficScenarios.json'
const base_url = 'https://model-coordinator-api.bi-ped.civora.org'; // http://127.0.0.1:5001 // https://model-coordinator-api.bi-ped-staging.civora.org

export default {
  name: "App",
  data() {
    return {
      selectedOption: null, // Selected value
      options: [], // Dropdown options
      previousJobs: [],
      resultMessage: "", // Message to display after execution
      scenarios: trafficScenarios,
      resultData: "",
    };
  },
  mounted() {
    // Fetch data when component is mounted
    this.fetchData();
  },
  methods: {
    fetchData() {
      fetch(`${base_url}/api/processes/`)
        .then(response => response.json())
        .then(data => {
          this.options = data.processes; // Set fetched data
          // If you need DataTables, use native Vue methods or reinitialize DataTables as needed.
        });
      fetch(`${base_url}/api/jobs/?limit=8`)
        .then(response => response.json())
        .then(data => {
          this.previousJobs = data; // Set fetched data
          // If you need DataTables, use native Vue methods or reinitialize DataTables as needed.
        });
    },
    executeAction() {
      if (this.selectedOption) {
        //this.resultMessage = `You selected: ${this.selectedOption}`;
        //console.log(`Action executed for: ${this.selectedOption}`);
        const requestHeaders = {
          "accept": "application/json",
          "Content-Type": "application/json",
        }
        let requestBody

        if (this.selectedScenario) {
          requestBody = this.selectedScenario;
        } else {
          requestBody = {};
        }
        
        const requestOptions = {
          method: "POST",
          headers: requestHeaders,
          body: JSON.stringify(requestBody),
          redirect: "follow"
        };

        fetch(`${base_url}/api/processes/${this.selectedOption}/execution`, requestOptions)
          .then((response) => response.json())
          .then(data => {
            this.resultMessage = data;//.status;
            fetch(`${base_url}/api/jobs/?limit=8`)
              .then(response => response.json())
              .then(data => {
                this.previousJobs = data; // Set fetched data
                // If you need DataTables, use native Vue methods or reinitialize DataTables as needed.
              });
          })
          .catch((error) => {
            console.error(error);
            this.resultMessage = 'Error when trying to execute the model.';
          });
      } else {
        this.resultMessage = "Please select an option before executing.";
      }
    },
    dataPreview(jobId) {
      fetch(`${base_url}/api/jobs/${jobId}/results`)
        .then(response => response.json())
        .then(data => {
          this.resultData = data.job_results; // Set fetched data
          // If you need DataTables, use native Vue methods or reinitialize DataTables as needed.
        });
    },
  },
};
</script>

<style scoped>
#app {
  font-family: Sofia Sans Condensed, Arial, sans-serif;
  background-color: #f5f7fa;
  text-align: center;
  margin-top: 10px;
}
label {
  font-size: 16px;
}
select {
  margin: 0 10px;
  padding: 5px;
  font-size: 16px;
}
button {
  padding: 10px 15px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 3px;
}
button:hover {
  background-color: #0056b3;
}
p {
  font-size: 18px;
  color: #333;
  margin-top: 20px;
}
.green-text {
  color: green;
}
</style>
